<template>
  <v-lazy>
    <router-view>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </router-view>
  </v-lazy>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.v-application--wrap {
  background-color: #000000 !important;
}

/* Garantir que a barra de menu fique sempre no topo */
.v-app-bar {
  z-index: 1000 !important;
}

.v-app-bar.v-app-bar--fixed {
  z-index: 1000 !important;
}

/* Navigation drawer acima do app-bar e do seu próprio scrim */
.v-navigation-drawer {
  z-index: 1100 !important;
}

/* Scrim do drawer: acima do app-bar mas abaixo do drawer */
.v-overlay {
  z-index: 1001 !important;
}

/* Garantir que dialogs fiquem acima de tudo */
.v-dialog__content {
  z-index: 1200 !important;
}

.v-dialog__content .v-overlay {
  z-index: 1199 !important;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  width: 100%;
  overflow-x: hidden;
}

body {
  width: 100%;
  margin: 0;
  padding: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.9s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
